module.exports = __webpack_public_path__ + "img/default-avatar.a1600425.svg";